import { EmploymentItem } from './employment-model';

export const getEmploymentItemById = (items: EmploymentItem[], id: string) => {
    return items?.filter(x => x.id === parseInt(id, 10))[0];
};

export const getCurrentEmploymentItem = (items: EmploymentItem[]) => {
    if (!items) return null;

    return items?.filter(x => !x.end_date)[0] || items[0];
};